import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {Card, CardContent, CardText} from "@css/common.elements";
import {fontSize} from "@css/styles";
import {ipadproMax, marketingMobileCuttoff, lochmaraBlue, blue} from "@css/constants";
import {FontNormal} from "@css/fonts";

export const RelatedArticleCardContainer = styled('div')(css`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: right;

  @media(max-width: ${marketingMobileCuttoff}) {
    display: none;
  }
`)

export const RelatedArticleCardContent = styled(CardContent)(css`
  padding: 25px 0;
  width: 75%;

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 85%;
  }
`)

export const RelatedArticleStyledCard = styled(Card)(css`
`)

export const RelatedArticleCardSubtitle = styled(CardText)(css`
  ${fontSize(14)};
`)

export const RelatedArticleCardLink = styled('a')(css`
  ${fontSize(16)};
  ${FontNormal(400)};
  text-decoration-line: underline;
  color: ${lochmaraBlue};
  cursor: pointer;
`)

export const RelatedArticleCardLinkSelected = styled('p')(css`
  ${fontSize(16)};
  ${FontNormal(600)};
  color: ${blue};
`)
